

import { BusinessContext } from '../../../providers/BusinessContext';
import { CartProvider, CartContext } from '../../../providers/CartContext';

import useTranslations from "../../../providers/useTranslations";

const Header = (props) => {
  return (
    <CartProvider>
      <HeaderPage {...props} />
    </CartProvider>
  )
}

const HeaderPage = (props) => {
  const { business, menu, itemsInCart, toggleCart, showHistory } = props;

  const ref = React.useRef(0);
  const [isNavExpanded, setIsNavExpanded] =React.useState(false);

  const { selectedBusiness } = React.useContext(BusinessContext);
  const { cartItems, totalItemsCost } = React.useContext(CartContext);

  const { tr, getTranslations, locale, translations, setLocale } = useTranslations();

  const closeMenu = () => {
    setIsNavExpanded(false);
  }

  React.useEffect(() => {
    //console.log("useEffect cartItems", cartItems)
/*
    document.addEventListener('click', (event) => {
      console.log("click handler",  event.target.matches('.historyLink'), event.target)
      if (!event.target.matches('.dropbtn')) {
        closeMenu()
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }, false); */


  }, [selectedBusiness, cartItems])

  const locationName = () => {
    if (menu && menu.Location) {
      let parts = [menu.Location.name, menu.Location.address]

      if (menu.Location.city && parts.indexOf(menu.Location.city) == -1) {
        parts.push(menu.Location.city)
      }

      return (
        <div style={{ fontSize: 12 }}>
          {parts.join(", ")}
        </div>
      )
    }
  }

  const headerImage = () => {
    if (business) {
      return (
        <img src={business.photo} alt='' style={{
          maxWidth: 110,
          maxHeight: 110
        }} />
      )
    }
    return (
      <img src="/images/zono-logo-smile.png" alt='' />
    )
  }

  //console.log("render header with", isNavExpanded)

  return (
    <div  >
      <div className="navbar">

        <div className="dropdown">
          <i className="fa-solid fa-bars fa-2x dropbtn" onClick={(event) => {

            setIsNavExpanded(!isNavExpanded)
          }}></i>
          {isNavExpanded &&
            <div id="myDropdown" class="dropdown-content show">
              <a className="nav-link" href="https://zono.cc" >
                Quiero mi página Zono<span className="sr-only">(current)</span>
              </a>
              <a className="historyLink" onClick={(event) => {

                event.preventDefault()
                showHistory(true)
              }}>{tr('My Orders')}</a>

            </div>
          }

        </div>

        <div className="navbar-brand" style={{ cursor: 'pointer' }}   >
          <div onClick={() => {
            if (business && business.uuid && business.uuid != "") {
              window.location.href = `https://${business.uuid}.zono.cc`
            }


          }}>
            {headerImage()}
          </div>
        </div>

        <div className={`${itemsInCart.length === 0 ? '' : 'cart-color'} `}
          onClick={() => {
            if (itemsInCart.length == 0) {
              alert(tr("No items in the cart"))
            } else {
              toggleCart()
            }
          }}
        >
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: 26 }}>
            <i className='fa fa-shopping-cart '></i>
            <span className="px-1 " style={{ fontSize: 12 }} >{itemsInCart.length}</span>
          </div>
        </div>

      </div>

      <div className="centered">{locationName()}</div>

    </div>
  );
}

export default Header;

/*




<Nav.Link eventKey={0} as={NavLink} activeclassname="active" exact href="/listing">
     {tr('Restaurants')} <span className="sr-only">(current)</span>
   </Nav.Link> */
/* <Nav.Link eventKey={1} as={NavLink} activeclassname="active" >
  <i className='icofont icofont-sale-discount' /> {tr('Restaurants')} <Badge variant="danger"></Badge>
</Nav.Link> */
/* <Nav.Link eventKey={1} as={NavLink} activeclassname="active" href="/offers">
  <i className='icofont icofont-sale-discount' /> {tr('Offers')} <Badge variant="danger">{tr('New')}</Badge>
</Nav.Link> */
/* <NavDropdown title={tr('Restaurants')} alignRight className="border-0">
  <NavDropdown.Item eventKey={2.1} as={NavLink} activeclassname="active" href="/listing">{tr('Listing')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={2.2} as={NavLink} activeclassname="active" href="/detail">{tr('Detail + Cart')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={2.3} as={NavLink} activeclassname="active" href="/checkout">{tr('Checkout')}</NavDropdown.Item>
</NavDropdown>
<NavDropdown title={tr('Pages')} alignRight>
  <NavDropdown.Item eventKey={3.1} as={NavLink} activeclassname="active" href="/track-order">{tr('Track Order')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={3.2} as={NavLink} activeclassname="active" href="/invoice">{tr('Invoice')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={3.3} as={NavLink} activeclassname="active" href="/login">{tr('Login')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={3.4} as={NavLink} activeclassname="active" href="/register">{tr('Register')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={3.6} as={NavLink} activeclassname="active" href="/extra">{tr('Extra')}</NavDropdown.Item>

</NavDropdown> */
/* <NavDropdown alignRight
  title={
    <DropDownTitle
      className='d-inline-block'
      image="/img/user/4.png"
      imageAlt='user'
      imageClass="nav-osahan-pic rounded-pill"
      title={tr('My Account')}
    />
  }
>
  <NavDropdown.Item eventKey={4.1} as={NavLink} activeclassname="active" href="/myaccount/orders"><i className='icofont icofont-food-cart' /> {tr('Orders')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={4.2} as={NavLink} activeclassname="active" href="/myaccount/offers"><i className='icofont icofont-sale-discount' /> {tr('Offers')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={4.3} as={NavLink} activeclassname="active" href="/myaccount/favourites"><i className='icofont icofont-heart' /> {tr('Favourites')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={4.4} as={NavLink} activeclassname="active" href="/myaccount/payments"><i className='icofont icofont-credit-card' /> {tr('Payments')}</NavDropdown.Item>
  <NavDropdown.Item eventKey={4.5} as={NavLink} activeclassname="active" href="/myaccount/addresses"><i className='icofont icofont-location-pin' /> {tr('Addresses')}</NavDropdown.Item>
</NavDropdown>

{_cartDropdown()} */